import { removeDuplicateObj, content, setLocal, msg } from "src/utils/functions/core";
import { configData } from "src/utils/functions/queryFetch";
import { allinWeb, allinOne } from "src/utils/functions/queryFunction";

// Fetch config and web page data
const webPages = async () => {
  const config = await configData();
  const result = await allinWeb("getWebPages_001", { portalId: config?.portalId }, "web");
  return { result, config };
};

// Dynamically import available widgets
const webWidgets = async () => ({
  Empty: await import("src/components/Empty"),
  About: await import("src/webWidgets/core/About"),
  Login: await import("src/webWidgets/core/Login"),
  MultiLogin: await import("src/webWidgets/core/MultiLogin"),
  // Uncomment as needed
  // Register: await import("src/webWidgets/core/Register"),
  // Generic: await import("src/webWidgets/core/Generic"),
  // Home: await import("src/webWidgets/core/Home"),
  // ForgetPassword: await import("src/webWidgets/core/ForgetPassword"),
  // Faq: await import("src/webWidgets/core/Faq"),
  // PinNfcLogin: await import("src/webWidgets/core/PinNfcLogin"),
  // Jedi: await import("src/webWidgets/p_001/Jedi"),
  // Validation: await import("src/webWidgets/core/Validation"),
});

// Build app routes based on config and widget availability
const AppRoutes = async () => {
  const { result: pageData, config } = await webPages();
  const widgets = await webWidgets();

  setLocal("webBasicInfo", config);

  if (!Array.isArray(pageData?.tree)) {
    msg("error", "Config settings missing", 2);
    return [];
  }

  const pages = pageData.tree.map((el) => {
    const { pageName, layout = [], route, layoutComponent, runNum } = el;
    const Widget = widgets?.[pageName]?.default || widgets?.Empty?.default;

    return {
      ...el,
      element: <Widget layout={layout} />,
      path: pageName ? route : "*",
      comp: pageName || "Empty",
      runNum,
    };
  });

  const uniquePages = await removeDuplicateObj(pages, "comp");
  return uniquePages.sort((a, b) => a.runNum - b.runNum);
};

// Build admin-specific routes
const AppRoutesAdmin = async () => {
  const { user, portalId } = content();
  const pages = await allinOne("getPages001", {
    portalId,
    userGroupId: user?.references?.userGroupId?.$ref,
  });

  return pages.map((el) => {
    const path = el?.setUser ? `${el.route}?id=${user?._id}` : el.route;
    return {
      ...el,
      path,
      route: path,
      comp: el?.pageName,
    };
  });
};

export { AppRoutes, AppRoutesAdmin };
